import { render, staticRenderFns } from "./batchUploadFile.vue?vue&type=template&id=69c2c6d6&"
import script from "./batchUploadFile.vue?vue&type=script&lang=js&"
export * from "./batchUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c2c6d6')) {
      api.createRecord('69c2c6d6', component.options)
    } else {
      api.reload('69c2c6d6', component.options)
    }
    module.hot.accept("./batchUploadFile.vue?vue&type=template&id=69c2c6d6&", function () {
      api.rerender('69c2c6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/batchUploadFile.vue"
export default component.exports